export default {"src":"/_next/static/media/faq.dc2d7e55.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};